const lo = require('lodash')
const sb = require('@sb/util')
var api = require('./api.js')
const flow = require('@subiz/flow')
import KV from './kv.js'
import InMemKV from './inmem_kv.js'
import NewObjectStore from './object_store.js'
const config = require('@sb/config')
import common from './common.js'

// parent {api, realtime, insync, pubsub}
function TicketStore(realtime, pubsub) {
	let kv = new InMemKV()
	kv.init()

	let me = {}
	realtime.onEvent(async (ev) => {})

	let lastSeenTicketMenu = 0

	realtime.subscribe([
		'ticket_history_updated',
		'ticket_created',
		'ticket_updated',
		'ticket_view_updated',
		'ticket_rated',
	])

	realtime.onEvent(async (ev) => {
		if (!ev || !ev.type) return
		let ticket = {}
		switch (ev.type) {
			case 'ticket_view_updated':
				let views = lo.get(ev, 'data.views') || []
				if (!lo.size(views)) return
				pubsub.publish('ticket_view_updated', views)
				return
			case 'ticket_history_updated':
				let ticketid = lo.get(ev, 'data.ticket_history_entry.ticket_id', '')
				if (!ticketid) return
				let hist = kv.match('ticket_history_' + ticketid)
				if (!hist) return
				let entry = lo.get(ev, 'data.ticket_history_entry')
				if (!lo.get(entry, 'event')) return
				hist.push(lo.get(entry, 'event'))
				kv.put('ticket_history_' + ticketid, hist)
				// todo becareful for updating comment (which is not supported yet)
				pubsub.publish('ticket_history', entry)
				break
			case 'ticket_created':
			case 'ticket_updated':
				ticket = lo.get(ev, 'data.ticket')
				db.put(ticket.id, ticket)
				pubsub.publish('ticket', ticket)
				return
			case 'ticket_rated':
				ticket = lo.get(ev, 'data.ticket') || {}
				pubsub.publish('ticket_rated', ticket)
				return
		}
	})

	me.onTicketHistory = (o, cb) => pubsub.on2(o, 'ticket_history', cb)
	me.onTicket = (o, cb) => pubsub.on2(o, 'ticket', cb)
	me.onTicketRated = (o, cb) => pubsub.on2(o, 'ticket_rated', cb)
	me.onTicketView = (o, cb) => pubsub.on2(o, 'ticket_view_updated', cb)
	me.onTicketsRead = (o, cb) => pubsub.on2(o, 'tickets_read', cb)

	me.seenTicketMenu = () => {
		lastSeenTicketMenu = Date.now()
	}
	me.matchLastSeenTicketMenu = () => lastSeenTicketMenu

	let db = NewObjectStore(
		realtime,
		pubsub,
		'ticket',
		async (tickets) => {
			let ids = lo.map(tickets, 'id')
			let last_modifieds = lo.map(tickets, (ticket) => ticket.updated || 0)
			let {body, code, error} = await api.matchTickets(ids, last_modifieds)
			if (error || code !== 200) return {error}
			let out = lo.get(body, 'tickets', [])

			let os = []
			lo.map(out, (ticket) => {
				let i = lo.findIndex(ids, (id) => ticket.id == id)
				if (i == -1) return
				if (lo.size(ticket) < 2) delete ticket.id // no updates, must delete id to tell object store
				os[i] = ticket
			})

			return {data: os}
		},
		[],
		true,
	)

	me.updateTicket = async (ticket, fields) => {
		let description = ticket.description
		if (description) {
			let {message: newMessage, error} = await common.replaceMessageBase64Images(ticket.description)
			if (error) return {error: 'invalid_attachment_url'}
			ticket.description = newMessage
		}
		var {error, body: ticket} = await api.update_ticket(ticket, fields)
		if (error) return {error}
		db.put(ticket.id, ticket)
		return ticket
	}

	me.updateLastSelectedTicket = (ticketid) => kv.put('last_selected_ticket_id', ticketid)
	me.getLastSelectedTicket = () => kv.match('last_selected_ticket_id')

	me.createTicket = async (ticket) => {
		let description = ticket.description
		if (description) {
			let {message: newMessage, error} = await common.replaceMessageBase64Images(ticket.description)
			if (error) return {error: 'invalid_attachment_url'}
			ticket.description = newMessage
		}
		var {error, body: ticket} = await api.create_ticket(ticket)
		if (error) return {error}
		db.put(ticket.id, ticket)
		return ticket
	}

	me.deleteTicket = async (id) => {
		var {error, body: ticket} = await api.delete_ticket(id)
		if (error) return {error}
		db.del(ticket.id)
		return
	}

	me.matchTicket = (id) => {
		if (!id || id === '-') return undefined
		return db.match(id)
	}

	me.fetchTicket = async (id) => {
		let res = await api.get_ticket(id)
		if (res.error) return res
		let ticket = lo.get(res, 'body') || {}
		if (ticket.id) db.put(ticket.id, ticket)
		return res
	}

	me.fetchTickets = (ids, force) => db.fetch(ids, force)
	me.listTickets = async (query) => {
		let out = await api.list_tickets(query)
		lo.map(lo.get(out, 'body.tickets', []), (ticket) => {
			db.put(ticket.id, ticket)
		})
		pubsub.publish('ticket')
		return out
	}

	me.createTicketEvent = api.create_ticket_event
	me.rateTicket = api.rate_ticket
	me.matchTicketEvents = (ticketid) => {
		return kv.match('ticket_history_' + ticketid) || []
	}

  me.updateTicketMember = api.update_ticket_member
  me.removeTicketMember = api.delete_ticket_member

	me.fetchTicketEvents = async (ticketid) => {
		let out = await api.list_ticket_events(ticketid)
		if (out.error) return {error: out.error}
		let hist = lo.get(out, 'body.events') || []
		kv.put('ticket_history_' + ticketid, hist)
		return hist
	}

	me.readTickets = (ids) => {
		let {agent_id} = api.getCred() || {}
		// try to read ticket in store ticket
		lo.each(ids, (id) => {
			let storeticket = db.match(id)
			if (!storeticket) return // continue

			let members = lo.get(storeticket, 'members') || []
			let member = lo.find(members, (mem) => mem.id === agent_id)
			if (!member) {
				members.push({
					id: agent_id,
					type: 'agent',
					read_at: Date.now(),
				})
			} else {
				member.read_at = Date.now()
			}
			storeticket.members = members
			db.put(id, storeticket)
		})
		pubsub.publish('tickets_read', {ids})
		api.read_tickets(ids)
	}

	return me
}

export default TicketStore
